import { render, staticRenderFns } from "./liensandJudgment.vue?vue&type=template&id=858b61b8"
import script from "./liensandJudgment.vue?vue&type=script&lang=js"
export * from "./liensandJudgment.vue?vue&type=script&lang=js"
import style0 from "./liensandJudgment.vue?vue&type=style&index=0&id=858b61b8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports